"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCustomIndicatorSection = void 0;
const tslib_1 = require("tslib");
const defaultSubsections_1 = require("./helpers/defaultSubsections");
const dotty = require("dotty");
const DEFAULT_INDICATOR_SECTION_TITLE = 'Indicator ID #';
function makeCustomIndicatorSection(db, patients, section, indicator, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = [];
        for (const patient of patients) {
            const readings = yield db.get.readings.custom.forUser(patient._id, indicator._id);
            for (const reading of readings) {
                const rawEntry = yield makeCustomReadingRow(db, section, reading);
                rawEntry && data.push(rawEntry);
            }
        }
        const description = section.description ||
            indicator.name[(options === null || options === void 0 ? void 0 : options.language) || 'en' || 'fr'] ||
            `${DEFAULT_INDICATOR_SECTION_TITLE} ${indicator._id}`;
        const subtitles = section.subsections.reduce((acc, subsection) => {
            if (subsection.exclude)
                return acc;
            return [...acc, subsection.subtitle];
        }, []);
        return {
            title: section.title,
            description,
            subtitles,
            type: 'indicator',
            indicator: indicator._id,
            data,
        };
    });
}
exports.makeCustomIndicatorSection = makeCustomIndicatorSection;
function makeCustomReadingRow(db, sectionSchema, reading) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const rawEntry = {};
        for (const subsection of sectionSchema.subsections) {
            if (subsection.exclude)
                continue;
            if ('func' in subsection) {
                if (typeof subsection.func === 'string') {
                    const func = defaultSubsections_1.default[subsection.func];
                    if (func) {
                        rawEntry[subsection.subtitle] = yield func(db, reading);
                    }
                    else {
                        throw new Error(`Unknown default function ${subsection.func} in patient notes section`);
                    }
                }
                else {
                    throw new Error('Cannot use custom functions in patient notes section yet');
                }
            }
            else {
                // subsection accessor
                const accessor = subsection.dataAccessor;
                const datum = dotty.get(reading, accessor);
                rawEntry[subsection.subtitle] = datum;
            }
        }
        return rawEntry;
    });
}
//# sourceMappingURL=customIndicatorSection.js.map